import type { LucideIcon } from "lucide-react";
import { PALETTE, BG_PALETTE } from "../lib/theme";

interface Props {
  colorIndex: number;
  Icon: LucideIcon;
  titre: string;
}

export function SectionHeader({ colorIndex, Icon, titre }: Props) {
  const color = PALETTE[colorIndex];
  const bg = BG_PALETTE[colorIndex];
  return (
    <div
      className="mb-4 flex items-center gap-3 rounded-xl px-3.5 py-3"
      style={{ background: bg }}
    >
      <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-white shadow-sm">
        <Icon size={20} color={color} strokeWidth={1.8} />
      </div>
      <div className="text-base font-semibold text-slate-900">{titre}</div>
    </div>
  );
}
